import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarService } from '../../shared/sidebar/sidebar.service';
import { HelperService } from '../../shared/services/helper.service';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit {
    public isEmbeddedMode = false;

    constructor(
        public sideBarService: SidebarService,
        private router: Router,
        private helperService: HelperService
    ) { }

    public ngOnInit(): void {
        this.isEmbeddedMode = this.helperService.embeddedMode.get();
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    getSideBarState() {
        return this.sideBarService.getSidebarState();
    }

    public toggleSidebar(): void {
        this.sideBarService.setSidebarState(!this.sideBarService.getSidebarState());
    }

    public hideSidebar(): void {
        this.sideBarService.setSidebarState(true);
    }

}
